import { PivotModel } from 'api-hooks/common';
import { ExportableReportType } from 'api-hooks/general/model';
import { Expose, Type } from 'class-transformer';
import { Filter } from 'common/repositories/common.model';

export class getReportsInput {
  params?: any;
}

export class ReportingResultModel {
  data: any[];

  @Type(() => Filter)
  filters: Filter;

  @Type(() => PivotModel)
  pivot: PivotModel;
}

export class ReportTourDetailShowModel {
  id: string;
  code: string;
  name: string;

  @Expose({ name: 'completed_at' })
  @Type(() => Date)
  completedAt: Date | null;

  @Expose({ name: 'departed_at' })
  @Type(() => Date)
  departedAt: Date | null;

  @Expose({ name: 'transaction_at' })
  @Type(() => Date)
  transactionAt: Date;

  @Expose({ name: 'total_participant' })
  @Type(() => Number)
  totalParticipant: number;
}

export class ReportTourDetailSaleModel {
  customer: string;
  number: string;
  participants: string;

  @Expose({ name: 'completed_at' })
  @Type(() => Date)
  completedAt: Date | null;

  @Expose({ name: 'transaction_at' })
  @Type(() => Date)
  transactionAt: Date;

  @Type(() => Number)
  sales: number;

  @Type(() => Number)
  tipping: number;
}

export class ReportTourDetailPurchaseModel {
  customer: string;
  number: string;
  guests: string;

  @Expose({ name: 'completed_at' })
  @Type(() => Date)
  completedAt: Date | null;

  @Expose({ name: 'transaction_at' })
  @Type(() => Date)
  transactionAt: Date;

  @Type(() => Number)
  purchase: number;
}

export class ReportTourDetailCommissionModel {
  employee: string;
  role: string;

  @Expose({ name: 'commission_per_pax' })
  @Type(() => Number)
  commissionPerPax: number;

  @Expose({ name: 'no_of_pax' })
  @Type(() => Number)
  noOfPax: number;

  @Expose({ name: 'total_commission' })
  @Type(() => Number)
  totalCommission: number;
}

class ReportTippingModel {
  id: string;
  number: string;
  account: string;
  description: string;
  amount: number;

  @Expose({ name: 'transaction_at' })
  @Type(() => Date)
  transactionAt: Date;

  @Expose({ name: 'account_type' })
  accountType: string;
}

export class ReportTourDetailOtherExpenseModel extends ReportTippingModel {}

export class ReportTourDetailOtherIncomeModel extends ReportTippingModel {
  @Expose({ name: 'acknowledged_at' })
  @Type(() => Date)
  acknowledgedAt: Date;
}

// Input

export class getReportTourDetailShowInput {
  tourRefId: string;
}

export class getReportTourDetailsInput {
  params: {
    tourRefId?: string;
    page: number;
    limit?: number;
    filter?: string;
  };
}

export class ReportTourExportInput {
  tourRefId: string;
}

export class ReportExportExcelInput {
  type?: ExportableReportType;
  body?: any;
}
